<template>
  <div>
    <div v-for="(typeGroup, typeIndex) in groupedByType(activityAudits)" :key="typeIndex">
      <table class="finding">
        <tr style="background-color: lightgray; color: black; text-align: center;">
          <th>
            {{ typeGroup.activityAuditTypeName }}
          </th>
        </tr>
      </table>

      <table class="stripe" style="border-top-left-radius: 0px; border-top-right-radius: 0px;">
        <thead>
          <tr style="text-align: left;">
            <th style="width: 25%;">Activity</th>
            <th style="width: 15%;">Handled Correctly</th>
            <th style="width: 40%;">Notes</th>
            <th style="width: 20%;">Reason</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, idx) in flattenedRowsByCodeType(typeGroup.rows)" :key="'ar-' + typeIndex + '-' + idx">
            <template v-if="item.isHeader">
              <td colspan="4" class="codeTypeHeader">{{ item.codeType }}</td>
            </template>
            <template v-else>
              <td style="color: black;">{{ item.row.activityName }}</td>
              <td style="color: black;">
                <span v-if="item.row.handledCorrectly === true">Yes</span>
                <span v-else-if="item.row.handledCorrectly === false">No{{ item.row.exclude ? ' (Excluded)' : '' }}</span>
                <span v-else>-</span>
              </td>
              <td style="color: black;">{{ item.row.notes || '' }}</td>
              <td style="color: black;">{{ item.row.reasonForChange || '-' }}</td>
            </template>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="!activityAudits || activityAudits.length === 0">
      <div style="font-style: italic; font-size: 14px;">No activity audits on Worksheet</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ProWorksheetActivityAudits',
    props: {
      activityAudits: {
        type: Array,
        default: function() {
          return []
        }
      }
    },
    methods: {
      groupedByType(arr) {
        if (!arr) return []
        const typeNames = [...new Set(arr.map(x => x.activityAuditTypeName))].sort()
        return typeNames.map(name => ({
          activityAuditTypeName: name,
          rows: arr.filter(x => x.activityAuditTypeName === name)
        }))
      },
      codeTypeLabel(row) {
        const c = row && row.codeType
        return c != null && String(c).trim() !== '' ? String(c).trim() : '-'
      },
      getCodeTypesForRows(rows) {
        if (!rows || !rows.length) return []
        const labels = rows.map(r => this.codeTypeLabel(r))
        return [...new Set(labels)].sort((a, b) => (a > b ? 1 : -1))
      },
      rowsForCodeType(rows, codeType) {
        if (!rows) return []
        return rows.filter(r => this.codeTypeLabel(r) === codeType)
      },
      flattenedRowsByCodeType(rows) {
        if (!rows || !rows.length) return []
        const out = []
        for (const codeType of this.getCodeTypesForRows(rows)) {
          out.push({ isHeader: true, codeType })
          for (const row of this.rowsForCodeType(rows, codeType)) {
            out.push({ isHeader: false, row })
          }
        }
        return out
      }
    }
  }
</script>

<style scoped>
  .codeTypeHeader {
    text-align: left;
    padding: 4px 0px 4px 5px;
    border-left: 8px solid #3378aa7c;
    font-style: italic;
  }
</style>
